import {keepPreviousData, useInfiniteQuery} from '@tanstack/react-query';

import {apiClient} from '../../../../../../utils/api-client';

export const CONNECTIONS_QUERY_PAGE_SIZE = 60;

interface Props {
    queryId: number;
    connectionId: number;
}

export function usePathConnectionsQuery(props: Props) {
    return useInfiniteQuery({
        queryKey: ['connection', props.queryId, props.connectionId],
        queryFn: async ({pageParam}) =>
            apiClient.get<PageResponse<PathEntryDto, number>>({
                path: `queries-service/api/queries/${props.queryId}/connection-path`,
                query: {
                    'connection-id': props.connectionId,
                    cursor: pageParam.cursor,
                    limit: pageParam.limit
                }
            }),
        getNextPageParam: ({nextCursor, remaining}) => {
            const hasNextPage = remaining > 0;
            if (hasNextPage) {
                return {
                    cursor: nextCursor,
                    limit: CONNECTIONS_QUERY_PAGE_SIZE
                };
            }
        },
        initialPageParam: {cursor: null, limit: CONNECTIONS_QUERY_PAGE_SIZE} as PageParams,
        placeholderData: keepPreviousData
    });
}
